import { action, makeObservable, observable, runInAction, computed } from "mobx";
import firebaseAgent from "../api/firebaseagent";
import { Category } from "../models/category";
import { BaseStore } from "./baseStore";
import { RootStore } from "./rootStore";

export default class CategoryStore extends BaseStore<Category> {    

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {            
        });
    }

    // Link this store to the specific service in firebaseAgent
    protected getService() {
        return firebaseAgent.categoryService;
    }

    // --- Aliases for compatibility ---
    get category() { return this.selectedItem || new Category(); }
    set category(val: Category) { this.selectedItem = val; }    
    get ParentCategories() { return this.items.filter(c=> (c.parentID == undefined || c.parentID == null)); }
    // --- Computed Properties (Sorting & Filtering) ---
    get categoryByName() {
        return [...this.items].sort((a, b) => 
            (a.name || "").localeCompare(b.name || "")
        );
    }
}